/* Uses Shopify's configured native banner. Consent is only changed in its own UI. */
(function () {
  'use strict';
  if (window.LRSLegalFooter) return;
  window.LRSLegalFooter = true;
  const ready = () => typeof window.privacyBanner?.showPreferences === 'function';
  const reveal = () => {
    if (!ready()) return;
    document.querySelectorAll('[data-lrs-cookie-item]').forEach(item => { item.hidden = false; });
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-lrs-cookie-preferences]');
    if (!button || button.disabled) return;
    const root = button.closest('[data-lrs-legal-footer]');
    const help = root?.querySelector('[data-lrs-cookie-help]');
    if (help) help.hidden = true;
    button.disabled = true;
    try {
      if (!ready()) throw new Error('Native privacy banner unavailable');
      await window.privacyBanner.showPreferences();
    } catch (_) {
      if (help) help.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
  document.addEventListener('DOMContentLoaded', reveal, { once: true });
  window.addEventListener('load', reveal, { once: true });
  document.addEventListener('load', event => { if (event.target.tagName === 'SCRIPT') reveal(); }, true);
  document.addEventListener('shopify:section:load', reveal);
  reveal();
})();
